import { inject, Pipe, PipeTransform } from '@angular/core';
import { ProductsService } from '../../products/products.service';
import { InsuranceType } from '@models/insurance-type';

@Pipe({
    name: 'insuranceType',
    standalone: true,
})
export class InsuranceTypePipe implements PipeTransform {
    private productsService: ProductsService = inject<ProductsService>(ProductsService);
    public transform(value: InsuranceType, length?: 'short' | 'full' | 'collabsible'): string | null {
        const product = this.productsService.getCanonicalByInsuranceType(value);
        if (product) {
            switch (length) {
                case 'full':
                    return product.fullTitle;
                case 'collabsible':
                    return product.collapsableTitle;
                default:
                    return product.title;
            }
        }
        return 'nicht gefunden';
    }
}
